import 'regenerator-runtime/runtime';
import { call, cancel, put, takeEvery } from 'redux-saga/effects';
import {
  ANTRAGSNUMMER_EVENTS,
  DoRequestResponse,
  GlobalActions,
  GlobalPut,
} from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';
import { App } from '@ps20-frontend/frontend-models';
import { PS20Logger } from '@ps20-frontend/logging';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { PhActions } from '../phActions';

export function* watchAntragsnummerRequested() {
  yield takeEvery(GlobalActions.ANTRAGSNUMMER_REQUESTED, safeSaga(antragsnummerSaga, App.PH));
  yield takeEvery(PhActions.VORSCHLAGDATEN_CHANGED, safeSaga(antragsnummerSaga, App.PH));
  yield takeEvery(
    ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_SUCCESSFULL,
    safeSaga(successCallback, App.PH),
  );
}

export function* antragsnummerSaga(action: AnyAction) {
  if (action.payload?.appId === App.PH || action.type === PhActions.VORSCHLAGDATEN_CHANGED) {
    const globalPut = GlobalPut.getInstance();

    yield call(
      globalPut.put.bind(globalPut),
      new GlobalActions().doRequestAntragsnummer(
        App.PH,
        ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_SUCCESSFULL,
        ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_FAILED,
      ),
    );
  }
}

export function* successCallback(successAction: DoRequestResponse<string>) {
  try {
    if (successAction.doRequestAction.payload.appId === App.PH) {
      const globalPut = GlobalPut.getInstance();
      const antragsnummerAsString = successAction.payload.toString();
      yield put(new PhActions().antragsnummerGenerated(antragsnummerAsString));
      yield call([globalPut, globalPut.put], new GlobalActions().antragsnummerGenerated());
    }
  } catch (exception) {
    PS20Logger.error(
      App.PH,
      exception as Error,
      'antragsnummerSaga successCallback Antragsnummer konnte nicht verarbeitet werden',
    );
    yield cancel();
  }
}
